export default __webpack_public_path__ + "static/media/horn_three.310baddd.mp3";